import {Component, Inject, Optional} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import {ConfirmDialogComponent} from '../confirm-dialog/confirm-dialog.component';
import {CONTINUE_WITHOUT_SAVING} from '../../modules/sales-terminal/sales-terminal.constants';

@Component({
  selector: 'app-pending-changes-dialog',
  template: ''
})
export class PendingChangesDialogComponent {
  public dialogRef: MatDialogRef<ConfirmDialogComponent>;

  constructor(private dialog: MatDialog,
              private translateService: TranslateService,
              @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    let actions = [];
    if (!data?.noContinue) {
      actions.push({
        title: this.translateService.instant('general.api_continue_without_saving'),
        result: CONTINUE_WITHOUT_SAVING
      });
    }
    if (!data?.canNotSave && data?.actions?.length) {
      actions = actions.concat(data.actions);
    }
    this.dialogRef = dialog.open(ConfirmDialogComponent, {
      width: '30%',
      panelClass: 'xs-popup',
      data: {
        title: this.translateService.instant('general.api_title_unsaved_changes'),
        description: this.data?.pendingChangesDescription || this.translateService.instant('general.api_title_unsaved_changes_description'),
        buttonOk: this.data?.buttonOk || this.translateService.instant('general.api_save_and_continue'),
        buttonOkHidden: !!data?.canNotSave,
        buttonCancelHidden: data?.noContinue ? false : !data?.canNotSave,
        buttonCancel: this.translateService.instant('general.api_continue_filling'),
        additionalActions: actions
      }
    });
  }
}
